import moment from 'moment'
import 'moment/locale/es-mx';
import React, {useState, useEffect, useRef} from 'react'
import { Calendar as Calendar2, momentLocalizer, Views } from 'react-big-calendar'
import "react-big-calendar/lib/css/react-big-calendar.css";
import firebase from '../firebase/config'
import {useHistory} from 'react-router-dom';

import { es } from 'date-fns/locale'
import { getDay, isSameDay  } from 'date-fns'
import { DatePickerCalendar , useDateInput, Calendar, DatePicker } from 'react-nice-dates'
import 'react-nice-dates/build/style.css'
import utils from '../firebase/utils';

const localizer = momentLocalizer(moment)
moment.locale("es");

function Agenda(){
  const history = useHistory()
  // eslint-disable-next-line
  const [orders, setOrders] = useState([])
  const [tiposCate, setTiposCate] = useState([])
  const [cate, setCate] = useState("")
  const [tipoServicios, setTipoServicios] = useState([])
  const [serv, setServ] = useState("")
  // eslint-disable-next-line
  const [items, setItems] = useState([])
  const [myEventsList, setMyEventsList] = useState([])
  // eslint-disable-next-line
  const [user, setUser] = useState({})
  let [showCalendar, setShowCalendar] = useState(false)
  let [n, setN] = useState(false)

  const messages = {
    next: "Siguiente",
    previous: "Anterior",
    today: "Hoy",
    month: "Mes",
    week: "Semana",
    day: "Día",
  }

  let [blockedDays, setBlockedDays] = useState([])
  const url2 = window.location.href;

  let [allDays, setAllDays] = useState([])
  let [selectedDatesToBlock, setSelectedDatesToBlock] = useState([])
  let [selectedDates, setSelectedDates] = useState([])
  let [selectedDatesNumber, setSelectedDatesNumber] = useState(0)

  var modifiers = {
    blocked: date => blockedDays.some(selectedDate => isSameDay(selectedDate.toDate(), date)),
    selected: date => selectedDates.some(selectedDate => isSameDay(selectedDate, date))
  }

  const modifiersClassNames = {
    blocked: '-blocked'
  }

  const handleDayClick = date1 => {
    let selectedDatesNew = []
    let list = selectedDates
    
    selectedDates.forEach((d)=>{
      selectedDatesNew.push(d.getTime())
    })
    
    if(selectedDatesNew.includes(date1.getTime())){
      Promise.all(selectedDates.map(async (d, i) => {
          let index = moment(d)
          let index2 = moment(date1)
          let index3 = index.isSame(index2)
          return index3 
      })).then((ia)=>{
        let i = ia.indexOf(true)
        list.splice(i, 1)
        setSelectedDatesNumber(selectedDatesNumber + 1)
      })
      setSelectedDates(list)
    }else{
      setSelectedDates([...selectedDates, date1])
      // console.log("No lo contiene")
    }
  }

  const getOrders = async(id) =>{
    let tipos = [];
    
    const reference = firebase.db.collection('Ordenes').where("tipoOrden", "==", "Servicio").where("aliadoId", "==", id)
    const reference2 = firebase.db.collection('Ordenes').where("tipoOrden", "==", "Videoconsulta").where("aliadoId", "==", id)

    await reference.get().then(val => {
      val.docs.forEach(item=>{
        tipos.push(item.data())
      })
    })
    await reference2.get().then(val => {
      val.docs.forEach(item=>{
        tipos.push(item.data())
      })
    })
    setOrders(tipos)
    getItems(tipos)
  }
  
  const getItems = async(ordenes) =>{
    let tipos = [];
    ordenes.forEach(async(orden)=>{
      
    const reference = firebase.db.collection('Ordenes').doc(orden.oid).collection("Items")
    const serviceFilter = serv ? reference.where("titulo", "==", serv) : reference

      await serviceFilter.get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
          // console.log(item.data())
        })
      })

      //Filtrar las ordenes que solo estan disponibles
      //Dependiendo del rol
      // for(let i = 0; i < tipos.length; i++){
      //   for(let i = 0; i < ser.length; i++){
      //     if(ser[i] === tipos[i].titulo){
      //       tipos2.push(tipos[i])
      //     }
      //   }
      // }
      
      //Filtrar el rol del usuario y obtener todos los servicios
      //para asi filtrar las ordenes principales sin filtro
      // await firebase.db.collection("Aliados").doc(user.superAliadoId).collection("Roles").doc(user.rol).collection("CategoriasServicios").get().then((val)=>{
      //   val.docs.forEach((doc)=>{
      //     firebase.db.collection("Roles").doc(user.role).collection("CategoriasServicios").doc(doc.id).collection("Servicios").get().then((val2)=>{
      //       val2.docs.forEach((doc2)=>{
      //         tipos.push(doc.id)
      //       })
      //     })
      //   })
      // })

      formatEvents(tipos)
      setItems(tipos)
    })
    // console.log("Items: " + tipos)
  }
  
  const formatEvents = async(items) =>{
    let tipos = [];
    items.forEach(async(item)=>{

      let date = item.date === null ? moment().toDate() : item.date.toDate()
      const hn = "12:00"
      let hourL = item.hora === null ? hn.split(":") : item.hora.split(":") 
      
      date.setHours(hourL[0])
      date.setMinutes(hourL[1])
      
      let fecha = item.fecha
      let dateFormatted = moment(item.date.toDate()).format("ddd, D MMM YYYY")
      
      if(fecha !== dateFormatted){
        let dd = moment(item.date.toDate()).add(1, "d")
        date = dd.toDate()
        date.setHours(hourL[0])
        date.setMinutes(hourL[1])
      }

      var event = {
        oid: item.oid,
        title: `${item.titulo} - ${item.nombre} - ${item.atendidoStatus ?? "Por atender"}`,
        start: item.date === null ? moment().toDate() : date,
        end: item.date === null ? moment().toDate() : moment(date).add(30, "minutes").toDate(),
        allDay: false
      }
      
      tipos.push(event)
    })
    setMyEventsList(tipos)
  }

  async function checkBlockDays(){
    let array = []

    await Promise.all(selectedDates.map(async (blockedDay, i) => {
      items.forEach((dayInReserved)=>{
        if(moment(blockedDay).format("ddd, MMM D YYYY") === moment(dayInReserved.date.toDate()).format("ddd, MMM D YYYY")){
          setN(true)
          // array.push(dayInReserved)
        }
      })
      allDays.forEach((dayInAgenda)=>{
        if(moment(blockedDay).format("ddd, MMM D YYYY") === dayInAgenda.fecha){
          array.push(dayInAgenda)
        }
      })
    })).then(()=>{
      setSelectedDatesToBlock(array)
      if(!n) setBlockDays(array)
    })

    
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {

      function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
              setShowCalendar(false)
          }
      }
    
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
          document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  function uniqBy(a, key) {
    var seen = {};
    return a.filter(function(item) {
        var k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    })
  }

  async function setBlockDays(list){
    let array = [...blockedDays]
    Promise.all(list.map(async (d) => {
      array.push(moment(d.date).toDate())
    }))
    let a = uniqBy(array, JSON.stringify)
    await firebase.db.collection("Aliados").doc(user.aliadoId).update({
      diasBloqueados: a
    }).then(()=>{
      list.forEach((dia)=>{
        firebase.db.collection("Localidades").doc(dia.localidadId).collection("Servicios").doc(dia.servicioId).collection("Agenda").doc(dia.fecha).update({
          bloqueado: true
        })
      })
      setN(false)
      setSelectedDates([])
      getUserBlockedDays(user.aliadoId)
      // console.log(array)
    })
  }

  function getCategories(u){
    let tipos = []
    let reference = u.role === "Administrador" ? firebase.db.collection("CategoriasServicios") : firebase.db.collection('Roles').doc(u.role).collection("CategoriasServicios")
    reference.get().then(data=>{  
      data.forEach(tipo=>{
        tipos.push(tipo.id)
        tipos.sort()
      })
      // tipos.pop("Todas")
      setTiposCate(tipos)
    });
  }

  function getServicesCategories(cate){
    let tipos = [];
    let reference = user.role === "Administrador" ? firebase.db.collection("CategoriasServicios").doc(cate).collection("Servicios") 
    : firebase.db.collection('Roles').doc(user.role).collection("CategoriasServicios").doc(cate).collection("Servicios")

    reference.get().then(data=>{
      data.docs.forEach(item=>{
        tipos.push(item.id)
      })
      setTipoServicios(tipos)
    });
  }
  
  function getUserBlockedDays(id){
    firebase.db.collection('Aliados').doc(id).get().then(data=>{
      setBlockedDays(data.data().diasBloqueados !== undefined ? data.data().diasBloqueados : [] )
    });
  }

  useEffect(() => {
    firebase.getCurrentUser().then((val)=>{
      setUser(val)
      getOrders(val.aliadoId)
      getUserBlockedDays(val.aliadoId)
      getCategories(val)
      utils.getAllDaysAgenda(val.aliadoId).then((val)=>{
        // console.log(val)
        setAllDays(val)
      })
    });
    // navigator.userAgent.indexOf("Firefox") != -1 ? alert("Firefox") : alert("Chrome")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
    return (
      <div className="main-content-container container-fluid px-4">

        <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
          <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
            <div className="row align-items-center">
              <div className="col">
                <p className="page-title"> <span>Agenda</span></p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-1 mb-0">
            <div className="row align-items-center justify-content-space-around">
              <i className="material-icons color-white display-5">help_outline</i>
            </div>
          </div>
        </div>
        <div className="form-row align-items-center justify-content-space-between">
            <div className="form-group mr-3">
              <select className="form-control" value={cate} onChange={(e) =>{ setCate(e.target.value); getServicesCategories(e.target.value) } }>
                <option value="">Selecciona la categoría:</option>
                {tiposCate.map(data => (
                    <option key={data} value={data}>{data}</option>
                ))}
              </select>
            </div>
            {cate === "" ? <div></div> : <div className="form-group">
              <select className="form-control" value={serv} onChange={e => setServ(e.target.value)}>
                <option value="">Selecciona el servicio:</option>
                {tipoServicios.map(data => (
                    <option key={data} value={data}>{data}</option>
                ))}
              </select>
            </div>}
          <div className="ml-3 form-group">
            <button className="btn btn-primary" onClick={()=>{getOrders(user.aliadoId)}}>Buscar <i className="material-icons">search</i></button>
          </div>
          { url2.includes("prioritypet-aliados") || url2.includes("localhost") ? <>
          {!showCalendar && <div className="ml-3 form-group">
            <div className="btn btn-secondary" onClick={()=>{ showCalendar ? setShowCalendar(false) : setShowCalendar(true) }} > Bloquear días <div style={{display: "none"}}>{selectedDatesNumber}</div> <i className="material-icons">{showCalendar ? "expand_less" : "expand_more" }</i></div>
          </div>}
          <div ref={wrapperRef} className={`calendar-w animated fadeIn ${showCalendar && "active"}`} style={{width: "390px"}}>
            <div className="p-2">
              <div className="btn btn-secondary" onClick={()=>{ setShowCalendar(false) }} > Cancelar <i className="material-icons">expand_less</i></div>
            </div>
            { n ? 
            <div className="calendar-alert">
              <p className="calendar-alert-title">{user.nombre} tienes citas confirmadas para el periodo seleccionado</p>
              <span className="calendar-alert-icon material-icons">error</span>
              <p className="calendar-alert-p">Le notificaremos a tus usuarios para que agenden una nueva cita</p>
            </div> 
            : <Calendar minimumDate={Date.now()} onDayClick={handleDayClick} modifiersClassNames={modifiersClassNames} modifiers={modifiers} locale={es} />}
            <div className="p-2">
              { n && <div onClick={()=>{setN(false)}} className={`btn btn-secondary btn-block`}>Regresar</div> }
              { n ?  
              <div onClick={()=>{setBlockDays(selectedDatesToBlock) }} className={`btn btn-danger btn-block`}>Continuar</div>
              : 
              <div onClick={()=>{selectedDates.length > 0 && checkBlockDays() }} className={`btn ${ selectedDates.length > 0 ? "btn-danger" : "btn-disabled"} btn-block`}>Bloquear</div> }
            </div>
          </div>
          </> : <></>}
        </div>
        <Calendar2
          onSelectEvent={(e)=>{
            history.push({
              pathname: "/orders/order", 
              state: { oid: e.oid }
            })
          }}
          defaultView="day"
          views={{month: true, week: true, day: true}}
          localizer={localizer}
          events={myEventsList}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          messages={messages}
        />
      </div>
    )

}

export default Agenda